<div class="w-full max-w-[520px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #f0fdf4; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">tune</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Monto mínimo Banco Plaza (payout VES)</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Tope nominal VES: solo BP procesa si el monto es menor o igual a este valor (además de los gates BCV 100/1000 USD).</p>
    </div>
  </div>

  <!-- Valor actual -->
  <div style="margin: 16px 24px; padding: 14px 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a;">payments</mat-icon>
      <div style="flex: 1;">
        <div style="font-size: 0.7rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #6b7280;">Valor actual</div>
        <div *ngIf="!loadingActual" style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">
          {{ valorActual !== null && valorActual > 0 ? formatVES(valorActual) : 'No configurado' }}
        </div>
        <div *ngIf="loadingActual" style="display: flex; align-items: center; gap: 6px;">
          <mat-spinner diameter="14"></mat-spinner>
          <span style="font-size: 0.78rem; color: #6b7280;">Cargando...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Form -->
  <div style="padding: 0 24px;" *ngIf="form">
    <form [formGroup]="form">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Nuevo monto mínimo (VES)</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">edit</mat-icon>
        <input matInput type="number" step="1" min="1" inputmode="numeric"
               formControlName="valor" placeholder="Ej: 100000" autocomplete="off" />
        <mat-hint>Número entero, sin puntos ni decimales.</mat-hint>
        <mat-error *ngIf="form.get('valor')?.hasError('required')">El monto es requerido</mat-error>
        <mat-error *ngIf="form.get('valor')?.hasError('min')">Debe ser mayor a 0</mat-error>
        <mat-error *ngIf="form.get('valor')?.hasError('pattern')">Solo dígitos (sin puntos, comas ni decimales)</mat-error>
      </mat-form-field>
    </form>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button (click)="guardar()" [disabled]="form.invalid || loading || loadingActual"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      [style.opacity]="form.invalid || loading || loadingActual ? '0.5' : '1'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">save</mat-icon>
      Guardar
    </button>
  </div>

</div>
